import React from "react";

const HelpCenter: React.FC = () => {
  return <div>Central de Ajuda</div>;
};

export default HelpCenter;
